import { stripMarkdownFormattingForMentions } from '../../../javascript/components/HighlightedMentions/stripMarkdownForPreview';

const CONTEXT_WORDS = 2;
const URL_INITIAL_MATCH_LIMIT = 24;
const URL_MATCH_CONTEXT = 12;
const URL_SNIPPET_LENGTH = 42;

export const getSearchTextSnippet = (text: string, query: string) => {
  const normalizedText = stripMarkdownFormattingForMentions(text)
    .replace(/\s+/g, ' ')
    .trim();
  const normalizedQuery = query.trim().toLowerCase();
  const matchStart = normalizedText.toLowerCase().indexOf(normalizedQuery);

  if (!normalizedQuery || matchStart === -1) return normalizedText;

  const words: { end: number; start: number; text: string }[] = [];
  normalizedText.replace(/\S+/g, (word, start) => {
    words.push({ end: start + word.length, start, text: word });
    return word;
  });

  const matchEnd = matchStart + normalizedQuery.length;
  const firstMatchWord = words.findIndex(word => word.end > matchStart);
  const lastMatchWord = words.findIndex(word => word.end >= matchEnd);
  const snippetStart = Math.max(firstMatchWord - CONTEXT_WORDS, 0);
  const snippetEnd = Math.min(
    (lastMatchWord === -1 ? firstMatchWord : lastMatchWord) + CONTEXT_WORDS + 1,
    words.length
  );

  return [
    snippetStart > 0 ? '…' : '',
    words
      .slice(snippetStart, snippetEnd)
      .map(word => word.text)
      .join(' '),
    snippetEnd < words.length ? '…' : ''
  ]
    .filter(Boolean)
    .join(' ');
};

export const getCommentSearchSnippet = getSearchTextSnippet;

export const getUrlSearchSnippet = (url: string, query: string) => {
  const text = url.trim();
  const normalizedQuery = query.trim().toLocaleLowerCase();
  const matchStart = text.toLocaleLowerCase().indexOf(normalizedQuery);

  if (!normalizedQuery || matchStart === -1) {
    return `${text.slice(0, URL_SNIPPET_LENGTH)}${
      text.length > URL_SNIPPET_LENGTH ? '…' : ''
    }`;
  }

  const matchEnd = matchStart + normalizedQuery.length;
  const snippetLength = Math.max(
    URL_SNIPPET_LENGTH,
    normalizedQuery.length + URL_MATCH_CONTEXT
  );
  const snippetStart =
    matchStart > URL_INITIAL_MATCH_LIMIT
      ? Math.max(0, matchStart - URL_MATCH_CONTEXT)
      : 0;
  let snippetEnd = Math.min(text.length, snippetStart + snippetLength);

  if (snippetEnd < matchEnd) snippetEnd = matchEnd;

  return `${snippetStart > 0 ? '…' : ''}${text.slice(
    snippetStart,
    snippetEnd
  )}${snippetEnd < text.length ? '…' : ''}`;
};

export const getMatchedTaskUrl = (
  matches: string[],
  site?: string | null,
  path?: string | null,
  pageQuery = ''
) => {
  if (!pageQuery && !matches.includes('url')) return undefined;

  return `${site || ''}${path || ''}` || undefined;
};
